import { render } from "./DownBar.vue?vue&type=template&id=1ca056c7"
import script from "./DownBar.vue?vue&type=script&lang=js"
export * from "./DownBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__